import { firebase } from '../firebase.js';

const initialState = {
  username: '',
  password: '',
}

const signIn = (state = initialState, action) => {
  switch(action.type) {
    case 'USERNAME_CHANGE':
      return {
        ...state,
        username: action.username,
      }
    case 'PASSWORD_CHANGE':
      return {
        ...state,
        password: action.password,
      }
    default:
      return state;
  }
}

export default signIn



// WEBPACK FOOTER //
// ./src/reducers/signin.js